var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iphone-screen"},[_c('div',{staticClass:"iphone"},[_c('div',{staticClass:"screen"},[_c('div',{staticClass:"scroll-content"},[_c('div',{staticClass:"iphone-content"},[_c('div',{staticClass:"time"},[_vm._v(" 15:21 ")]),_vm._t("default")],2)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }